import { useRouter } from 'next/router'

import type { UUID } from '@/types/Id'

export const useActiveCompanyId = () => {
  const router = useRouter()
  const activeCompanyId = router.query.companyId || ''
  return {
    activeCompanyId: (typeof activeCompanyId === 'string'
      ? activeCompanyId
      : '') as UUID | '',
  }
}
